import { type FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useURLViewID } from "../../app-utils/hooks/useUrl.js";
import { type InputTableQuerySpec } from "../../graphql.js";
import { updateLastOpenNucleotideFeatureTableSpec } from "../../redux/modules/genome.js";
import { loadView } from "../../redux/modules/saved-view.js";
import { type IAppState } from "../../redux/reducer.js";
import { type ReduxDispatch } from "../../redux/redux-utils.js";
import GenomeRelatedEntitiesView from "./GenomeRelatedEntitiesView.js";
import ContigRelatedEntitiesView from "@/ui-modules/entities/ContigRelatedEntitiesView.tsx";

interface IRelatedGenomicFeaturesViewProps {
  toolbarElement?: React.ReactNode;
}

const GenomeRelatedGenomicFeaturesView: FC<IRelatedGenomicFeaturesViewProps> = (props) => {
  const dispatch = useDispatch<ReduxDispatch>();
  const viewId = useURLViewID();
  const lastOpenFeatureTableSpec = useSelector<IAppState, InputTableQuerySpec>(
    (state) => state.genome.lastOpenFeatureTableSpec,
  );

  useEffect(() => {
    if (viewId) {
      void dispatch(loadView(viewId)).then((view) => {
        dispatch(updateLastOpenNucleotideFeatureTableSpec(view?.state?.tableView?.tableQuerySpec));
      });
    }
  }, [dispatch, viewId]);

  return (
    <GenomeRelatedEntitiesView
      subtitle="List of Genomic Features"
      /* when looking at nu features, show a selection widget for the nu feature types (including markers)*/
      middleToolbarElement={props.toolbarElement}
      relatedEntitiesType={lastOpenFeatureTableSpec?.resultType}
      relatedEntitiesSubType={lastOpenFeatureTableSpec?.resultSubTypeId}
    />
  );
};

const ContigRelatedGenomicFeaturesView: FC<IRelatedGenomicFeaturesViewProps> = (props) => {
  const dispatch = useDispatch<ReduxDispatch>();
  const viewId = useURLViewID();
  const lastOpenFeatureTableSpec = useSelector<IAppState, InputTableQuerySpec>(
    (state) => state.genome.lastOpenFeatureTableSpec,
  );

  useEffect(() => {
    if (viewId) {
      void dispatch(loadView(viewId)).then((view) => {
        dispatch(updateLastOpenNucleotideFeatureTableSpec(view?.state?.tableView?.tableQuerySpec));
      });
    }
  }, [dispatch, viewId]);

  return (
    <ContigRelatedEntitiesView
      subtitle="List of Genomic Features"
      /* when looking at nu features, show a selection widget for the nu feature types (including markers)*/
      middleToolbarElement={props.toolbarElement}
      relatedEntitiesType={lastOpenFeatureTableSpec?.resultType}
      relatedEntitiesSubType={lastOpenFeatureTableSpec?.resultSubTypeId}
    />
  );
};

export { GenomeRelatedGenomicFeaturesView, ContigRelatedGenomicFeaturesView };
